<template>
  <div id="modal">
    <transition>
      <div v-if="show" class="modal-mask" role="alert" @click="show = false">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop="show = true">
            <div v-if="header" class="modal-header">
              <slot name="header">
                {{header}}
              </slot>
            </div>
            <div class="modal-body">
              <slot name="body">
                <div v-if="isHtml" v-html="message"></div>
                <pre v-else style="display: inline-block; font-family:ＭＳ Ｐゴシック; font-size: 110%;">{{message}}</pre>
              </slot>
              <div v-if="isRadio">
                <div class="form-group radio-block">
                    <div class="radio" id="workStyle-radio">
                        <div class="form-check" v-for="(val, index) in radioList" :key="index">
                            <input type="radio" :value="val" :id="index" name="radio" v-model="selectedRadioVal">
                            <label :for="index">{{ val }}</label>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <slot name="footer">
                <span v-if="footer">{{footer}}</span>
                <!-- 通常モーダル -->
                <div v-if="!isRadio">
                  <button class="modal-default-button btn btn-primary" @click.stop="clickYes()">
                    はい
                  </button>
                  <button class="modal-default-button btn btn-secondary" @click.stop="clickNo()">
                    キャンセル
                  </button>
                </div>
                <!-- ラジオボタンモーダル -->
                <div v-else>
                  <button class="modal-default-button btn btn-primary" @click.stop="selectedRadio()">
                    決定
                  </button>
                  <button class="modal-default-button btn btn-secondary" @click.stop="show = false">
                    キャンセル
                  </button>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
  },
  data() {
    return {
      show: false,
      isHtml: false,
      isRadio: false,
      header: '',
      message: '',
      footer: '',
      radioList: [],
      selectedRadioVal: null,
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    init() {
      this.header = ''
      this.message = ''
      this.footer = ''
      this.radioList = []
      this.selectedRadioVal = null
    },
    confirm(...args) {
      this.init()
      switch (args.length) {
        case 1:
          this.message = args[0]
          break
        case 2:
          this.header = args[0]
          this.message = args[1]
          break
        case 3:
          this.header = args[0]
          this.message = args[1]
          this.isHtml = args[2]
          break
      }
      this.show = true
    },
    radio(args) {
      this.init()
      this.isRadio = true
      this.header = args.header ? args.header : '選択してください'
      this.message = args.message ? args.message : ''
      this.radioList = args.options ? args.options : ''
      this.footer = args.footer ? args.footer : ''
      this.show = true
    },
    selectedRadio () {
      this.$emit('selected', this.selectedRadioVal)
      this.show = false
    },
    clickYes(){
      this.$emit('ok', true)
      this.show = false
    },
    clickNo(){
      this.$emit('no', true)
      this.show = false
    }
  }
}
</script>


<style lang="scss" scoped>
.v-enter-active, .v-leave-active {
  transition: opacity .5s;
}
.v-enter, .v-leave-to {
  opacity: 0;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  display: table;
  min-width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  display: inline-block;
  margin: 20px 0;
  overflow: scroll;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>


// WEBPACK FOOTER //
// src/assets/js/components/Modal.vue